export default __webpack_public_path__ + "static/media/green_pawn.539daefe.png";